import JsonApi from "./jsonApi";

export const getMarkUpForFeatures = (featuresArray = []) => {
  const arrayIds = featuresArray.map(dbFeature => dbFeature.id);
  return JsonApi.getMarkUpForFeatures(arrayIds)
    .then(response => response.data)
    .catch(error => {
      console.log("Server error getMarkUpForFeatures "+new Error(error));
    })
};
